import React from "react";
import { classNames } from "./utils";

function Metric({ label, value, tone, onClick, active }) {
  const toneClass = {
    default: "text-zinc-900",
    danger: "text-red-600",
    success: "text-emerald-600",
    warning: "text-amber-600",
    primary: "text-indigo-600",
  }[tone] || "text-zinc-900";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className={classNames(
        "flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm transition-colors",
        onClick ? "cursor-pointer hover:bg-zinc-100" : "cursor-default",
        active ? "bg-zinc-100" : ""
      )}
    >
      <span className="text-[11px] font-medium uppercase tracking-wider text-zinc-500">
        {label}
      </span>
      <span className={classNames("text-base font-semibold tabular-nums", toneClass)}>
        {value ?? 0}
      </span>
    </button>
  );
}

export default function MetricStrip({ overview, onOpenView, smartView }) {
  const metrics = overview?.metrics || {};
  const enrolled = metrics.enrolled || 0;
  const dueToday = metrics.dueToday || 0;
  const awaitingReply = metrics.pendingReply ?? metrics.awaitingReply ?? metrics.pendingQueue ?? 0;
  const replied = metrics.replied || 0;

  return (
    <div className="flex flex-wrap items-center gap-1">
      <Metric
        label="Enrolled"
        value={enrolled}
        onClick={() => onOpenView?.("all")}
        active={smartView === "all"}
      />
      <span className="h-4 w-px bg-zinc-200" />
      <Metric
        label="Due today"
        value={dueToday}
        tone={dueToday > 0 ? "danger" : "default"}
        onClick={() => onOpenView?.("today")}
        active={smartView === "today"}
      />
      <span className="h-4 w-px bg-zinc-200" />
      <Metric
        label="Awaiting reply"
        value={awaitingReply}
        tone="primary"
        onClick={() => onOpenView?.("followups")}
        active={smartView === "followups"}
      />
      <span className="h-4 w-px bg-zinc-200" />
      <Metric
        label="Replied"
        value={replied}
        tone={replied > 0 ? "success" : "default"}
        onClick={() => onOpenView?.("replies")}
        active={smartView === "replies"}
      />
    </div>
  );
}
